import styled from "styled-components";
import { CSSEvent } from "../../types/model";
import sortEventsByStartDate from "../../utils/sortEventsByStartDate";
import Event from "../Event";

type EventProps = {
  events: Array<CSSEvent>;
  listLabel: string;
};

const List = styled.ul`
  list-style-type: none;
  display: grid;
  row-gap: var(--space-200);
  margin-bottom: var(--space-400);

  ${({ theme }) => `${theme.breakpoints.md} {
    column-gap: var(--space-150);
    row-gap: var(--space-150);
    grid-template-columns: repeat(2, 1fr);
  }`}

  ${({ theme }) => `${theme.breakpoints.llg} {
    grid-template-columns: repeat(3, 1fr);
  }`}

  ${({ theme }) => `${theme.breakpoints.xxl} {
    grid-template-columns: repeat(2, 1fr);
  }`}
`;

const EventList = ({ events, listLabel }: EventProps) => {
  const sortedEvents = events.sort(sortEventsByStartDate);
  return (
    <List aria-label={listLabel}>
      {sortedEvents.map((event: CSSEvent, i) => (
        <li key={i}>
          <Event event={event} />
        </li>
      ))}
    </List>
  );
};

export default EventList;
